import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LeftNavComponent } from '../../common-components/left-nav/left-nav.component';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, LeftNavComponent,],
    templateUrl: './layout.component.html'
})
export class LayoutComponent {

}
